export default "__VITE_ASSET__lsTBEvWh__"